import { Container, Heading, Stack } from '@hover/blueprint';
import { navigate } from 'gatsby';
import React, { useState } from 'react';
import { CHAT_WITH_A_REP_LINK } from '../../../constants';
import { DownloadAppModal } from '../../common';
import ArrowButton from '../../ui/ArrowButton';

const TrustedContent: React.FC = () => {
  const [isOpen, setOpen] = useState<boolean>(false);

  const toggleModal = () => {
    setOpen(!isOpen);
  };
  const navigateTo = () => navigate(CHAT_WITH_A_REP_LINK);

  return (
    <Container maxW={{ base: '100%', tablet: '2xl' }} px={500}>
      <Heading
        isLight
        size={{ base: 500, tablet: 600, desktop: 700 }}
        textAlign={{ base: 'center', desktop: 'left' }}
        marginBottom={{ base: 500, desktop: 500 }}
      >
        We’re trusted by the biggest (and smallest) names in home improvement.
      </Heading>
      <Heading
        isDisplay
        size={{ base: 300, tablet: 500 }}
        textAlign={{ base: 'center', desktop: 'left' }}
        marginBottom={{ base: 700, tablet: 800 }}
      >
        The best way to understand why people use HOVER, is to try it for
        yourself. Create a 3D model of your home with the phone you’re probably
        reading this on.
      </Heading>
      <Stack
        w="100%"
        justifyContent={{ base: 'center', desktop: 'flex-start' }}
        direction={{ base: 'column', tablet: 'row' }}
        spacing={500}
        alignItems="center"
      >
        <ArrowButton onClick={toggleModal} w={{ base: '100%', tablet: 'auto' }}>
          Try it on your home
        </ArrowButton>
        <ArrowButton
          w="auto"
          variant="minimal"
          onClick={navigateTo}
          // TODO(buttons): remove when we remove padding in Blueprint
          sx={{ div: { pl: 100, pr: 50 } }}
        >
          Chat with a rep
        </ArrowButton>
      </Stack>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
    </Container>
  );
};

export default TrustedContent;
